import { Component, OnInit } from '@angular/core';
import { Utilities } from '../../../helper/util';
import { InputComponent, MakeProvider } from '../input-component';

@Component({
  selector: 'app-email-input',
  templateUrl: './email-input.component.html',
  styleUrls: ['./email-input.component.scss', '../form-inputs-style.scss'],
  providers: [MakeProvider(EmailInputComponent)]
})
export class EmailInputComponent extends InputComponent implements OnInit {

  constructor() { super(); }

  ngOnInit() { }

  override didBlur() {
    if (this.validateOnBlur) {
      super.didBlur();
    }
  }

  override checkValidity() {
    super.checkValidity();
    if (this.isValid) {
      if (this.required || this.value.length > 0) {
        const valid = Utilities.isValidEmail(this.value);
        if (valid) {
          this.isValid = true;
          this.checkingValidity.emit(this);
        } else {
          this.focusInvalidElement(this.errorMessage ?? 'Please enter a valid email.');
        }
      }
    }
    return this.isValid;
  }
}
